export default {
    putOpinion: { method: 'put', url: 'api/secure/professor/opinion' },
    getAllOpinionGrade: { method: 'get', url: 'api/secure/common/opinion_grade' },
    postOpinion: { method: 'post', url: 'api/secure/common/opinion_enrollment_request' },
}